import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { EbMatomoComponent } from './eb-matomo.component'

@NgModule({
  imports: [EbMatomoComponent],
  exports: [EbMatomoComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        EbMatomoComponent: {
          component: EbMatomoComponent
        }
      }
    })
  ]
})
export class EbMatomoModule {}
